export default "__VITE_ASSET__3ab83939__"